<!-- <div class="abv_flx">
  <span class="exchange">Exchange</span>
  <div class="drpdwn_box">
    <div class="dropdown">
      <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
        aria-expanded="false">
        <img src="assets/images/new-logo.svg" class="img-fluid" alt="icon"> CredBull
        <img src="assets/images/binance.svg" class="img-fluid" alt="icon"> Binance
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li><a class="dropdown-item" role="button" href="javascript:void(0)"><img src="assets/images/binance.svg"
              class="img-fluid" alt="icon"> Binance</a></li>
        <li><a class="dropdown-item" role="button" href="javascript:void(0)"><img src="assets/images/bybit.svg"
              class="img-fluid" alt="icon"> Bybit</a></li>
      </ul>
    </div>
  </div>
</div> -->
<div class="coin_details zindex">
  <div class="card trade_card">
    <!-- <div class="card-header">
      <h2>BOT Pairs</h2>
    </div> -->
    <div class="card-body">
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="strategies-tab-pane" role="tabpanel" aria-labelledby="strategies-tab"
          tabindex="0">
          <ul class="nav nav-tabs bottab mt-2" id="myTab" role="tablist">
            <!-- <li class="nav-item" role="presentation"><button class="nav-link active" id="coin_one-tab" type="button"
                data-bs-toggle="tab" data-bs-target="#coin_one" role="tab" aria-controls="coin_one"
                aria-selected="true">DCA</button></li> -->
            <!-- <li class="nav-item" role="presentation"><button class="nav-link" id="coin_two-tab" type="button"
                data-bs-toggle="tab" data-bs-target="#coin_two" role="tab" aria-controls="coin_two"
                aria-selected="false">GRID</button></li> -->
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="strategy_filter">
              <div class="search_inp_div">
                <input type="text" placeholder="Search Pair" class="form-control search_inp" name="symbol"
                  autocomplete="off" (input)="handleSearchPair($event)">
                <i class="bi bi-search"></i>
              </div>
              <!-- <button class="settings_button" data-bs-toggle="modal" data-bs-target="#filter_bot_modal"><i
                  class="bi bi-sliders2"></i></button> -->
            </div>
<div class="table-wrapper">
  <table class="pair-table">
    <thead>
      <tr>
        <th>Pair</th>
        <th>Price</th>
        <th>
          <div class="d-flex align-items-center sort-btn" (click)="toggleChangeSort()" style="cursor: pointer;">
            <span>24H Change</span>
            
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let pair of pairs | textFilter: 'tikerRoot': searchPair; let i = index" [ngClass]="{ 'active': i === 0 }" (click)="changePair(pair)">
        <td>
          {{ pair.firstCurrencySymbol }}/{{ pair.secondCurrencySymbol }}
        </td>
        <td>
          {{ nFormatter(truncateDecimals(pair.markPrice, pair.secondFloatDigit)) }}
        </td>
        <td>
          <span [ngClass]="pair.change > 0 ? 'greenTxt' : 'redText'" class="d-flex align-items-center">
            {{ nFormatter(truncateDecimals(pair.change, pair.secondFloatDigit)) }}
            <img *ngIf="pair.change > 0" src="assets/images/uparrow.svg" class="pair-icon ms-1" />
            <img *ngIf="pair.change <= 0" src="assets/images/downarrow.svg" class="pair-icon ms-1" />
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>

        </div>
      </div>
    </div>
  </div>
</div>